<template>
  <div id="sectionPrint">
    <div class="container">
      <invoice-header
        :orderInfo="data"
        :class="hidden ? 'print:flex hidden' : ''"
        class="mb-5"
      ></invoice-header>
      <div class="section-info">
        <div class="pt-8 mb-8">
          <div class="rounded-md p-2 border border-gray-300 relative text-sm">
            <div
              class="title font-bold mb-5 absolute -top-3 px-5 right-5 bg-indigo-50"
            >
              {{ sectionTitle }}
              <span v-if="pageLabel" class="text-gray-500 mr-2">{{ pageLabel }}</span>
            </div>
            <div class="image-grid">
              <div v-for="(img, index) in images" :key="index" class="image-item">
                <img
                  :src="img.image"
                  class="rounded-md border border-gray-200"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.image-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 0.5rem;
}
.image-item {
  overflow: hidden;
  border-radius: 0.5rem;
}
.image-item img {
  width: 100%;
  height: auto;
  display: block;
}
@media print {
  .image-grid {
    gap: 0.75rem;
    padding: 0.25rem;
  }
  .image-item {
    break-inside: avoid;
  }
  .image-item img {
    width: 95%;
    margin: 0 auto;
  }
}
</style>
<script>
import invoiceHeader from "./OrderInfo";

export default {
  props: {
    data: Object,
    images: Array,
    sectionTitle: String,
    pageLabel: {
      type: String,
      default: "",
    },
    hidden: Boolean,
  },
  components: {
    invoiceHeader,
  },
};
</script>
